import { Scope } from "~/hooks/useScope";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { PoliciesAddQueryDetailPage } from "~/pages/shared/policy/PoliciesAddQueryDetailPage";

export type PoliciesAddQueryPageProps = {
  scope: Scope;
};

export function PlatformPoliciesAddQueryDetailPage({
  scope,
}: PoliciesAddQueryPageProps) {
  const { policyId = "" } = useParams();

  return (
    <PoliciesAddQueryDetailPage
      scope={scope}
      sectionLabel="Policies"
      renderBreadcrumbs={(policyName, queryName) => (
        <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
          <Link
            key="/dashboard"
            component={RouterLink}
            to={`/dashboard`}
            display="flex"
          >
            <HomeIcon fontSize="inherit" />
          </Link>
          <Link key="/policies" component={RouterLink} to={`/policies`}>
            Platform Policies
          </Link>
          <Link key="/policies/add" component={RouterLink} to={`/policies/add`}>
            Add Policies
          </Link>
          <Link
            key="/policies/add/policyId"
            component={RouterLink}
            to={`/policies/add/${encodeURIComponent(policyId)}`}
          >
            {policyName}
          </Link>
          <Typography key="/policies/add/policyId/queries/queryId">
            {queryName}
          </Typography>
        </Breadcrumbs>
      )}
    />
  );
}
